<template>
  <div>
    <GridComponent
      id="personList"
      ref="_grid"
      :data-source="_data"
      :allow-paging="true"
      :data-bound="dataBound"
      :allow-sorting="true"
      :sort-settings="sortOptions"
      width="100%"
      :row-selected="onSelected"
      :row-deselected="onDeselected"
      :action-failure="gridActionFailure"
      :page-settings="pageSettings"
    >
      <ColumnsDirective>
        <ColumnDirective
          field="personType"
          header-text=""
          :auto-fit="true"
          :template="'cTemplate'"
        >
          <template #cTemplate="{data}">
            <SogIcon
              v-show="data.personType==='Natural'"
              icon="mdi-account"
            />
            <SogIcon
              v-show="data.personType==='Legal'"
              icon="mdi-office-building"
            />
          </template>
        </ColumnDirective>
        <ColumnDirective
          field="personName"
          header-text="Name"
          :auto-fit="true"
        />
        <!--
        <ColumnDirective
          field="id"
          header-text="id"
          :auto-fit="false"
          :visible="false"
          wi
          :is-primary-key="true"
        />
-->
      </ColumnsDirective>
    </GridComponent>
  </div>
</template>

<script setup lang="ts">
import Person from "@/shared/model/person";
import {DataManager} from "@syncfusion/ej2-data/src/manager";
import {computed} from "vue";
import {ref} from "vue";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective
} from "@syncfusion/ej2-vue-grids";
import SogIcon from "@/shared/ui/SogIcon.vue";
import {gridActionFailure} from "@/shared/services/api";

interface Props {
  data?: Person[],
  selected?: (person?: Person) => void,
}

const props = withDefaults(defineProps<Props>(), {
    data: undefined, selected: undefined, selectedId: undefined
  }
)

const _grid = ref<InstanceType<typeof GridComponent> | null>(null)

const sortOptions = {columns: [{field: 'personName', direction: 'Ascending'}]}
const pageSettings = {pageSize: 10, pageSizes: ["All", 10, 25, 50, 100]}


const _dataManager = ref<DataManager | undefined>(undefined)

function dataBound() {
  //_grid.value?.hideScroll();
}

const _data = computed(() => {
  if (props.data) {
    if (!_dataManager.value)
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      _dataManager.value = new DataManager(props.data)
    return _dataManager.value
  }
  return undefined
})


function refresh() {
  _grid.value?.refresh()
}

function onSelected(args: any) {
  if (props.selected && args.data) {
    props.selected(args.data)
  }
}

function onDeselected(args: any) {
  if (props.selected && args.isInteracted) {
    props.selected(undefined)
  }
}


defineExpose({
  refresh
})


</script>

<style scoped>

</style>
